<template>
  <b-col cols="12" class="py-2">
    <b-row no-gutters>
      <b-col cols="12" class="border-bottom border-2">
        <b-row
          @click="toggle"
          no-gutters
          align-v="center"
          align-h="between"
          class="py-2 link-pointer"
        >
          <b-col cols="auto">
            <p class="text-blue-500 text-filter-label mb-0">{{ label }}</p>
          </b-col>
          <b-col
            cols="auto"
            v-b-toggle
            :aria-expanded="visible ? 'true' : 'false'"
            aria-controls="collapse-4"
            class="outline-white"
          >
            <b-icon-arrow-down-short
              :class="visible ? 'not-collapsed' : 'collapsed'"
              class="collapse-arrow"
              variant="primary"
              scale="2"
            ></b-icon-arrow-down-short>
          </b-col>
        </b-row>
      </b-col>
      <b-collapse v-model="visible" visible class="w-100">
        <b-row cols="12">
          <b-col v-if="showFilterInput" cols="12" class="mt-2 mb-1">
            <b-input-group>
              <b-form-input
                v-model="filterValue"
                class="border-right-0"
                :placeholder="$t('childrenFilter.label.search')"
              ></b-form-input>
              <template #append>
                <b-input-group-prepend is-text tag="span">
                  <b-icon-search font-scale="0.5" scale="2"></b-icon-search>
                </b-input-group-prepend>
              </template>
            </b-input-group>
          </b-col>
          <b-col v-if="showValidationWarning" cols="12" v-orphans>
            <p
              class="small mb-0 text-danger px-1 pt-1 d-flex align-items-center transition-all-1"
              style="height: 24px"
            >
              {{ $t('childrenFilter.validation.limit', { limit, label: validationLabel }) }}
            </p>
          </b-col>
          <b-col v-else-if="limit > 0" cols="12" v-orphans>
            <p
              class="small mb-0 text-blue-500 px-1 d-flex align-items-center transition-all-1"
              style="height: 24px"
            >
              <i class="notification-info" style="transform: scale(0.8)"></i>
              {{ $t('childrenFilter.validation.limitInfo', { limit, label: validationLabel }) }}
            </p>
          </b-col>
          <b-col
            cols="12"
            class="mt-2 filter-input-checkbox-area text-blue-500"
            :class="autoHeight ? 'auto-height' : ''"
          >
            <div v-if="!radio">
              <FormCheckbox
                :name="label"
                v-for="(option, index) in filteredOptions"
                :key="indexWithCheckboxValue(option, index)"
                class="py-1"
                :model-value="value"
                @update:model-value="$emit('input', $event)"
                :trueValue="checkboxValue(option)"
                :disabled="isCheckboxDisabled(option)"
              >
                <template #label>
                  <div v-orphans class="mt-1">{{ checkboxLabel(option) }}</div>
                </template>
              </FormCheckbox>
            </div>
            <div v-else class="custom-radio">
              <FormCheckbox
                v-for="(option, index) in filteredOptions"
                :key="indexWithCheckboxValue(option, index)"
                :name="label"
                class="py-1"
                :model-value="value"
                @update:model-value="$emit('input', $event)"
                :trueValue="checkboxValue(option)"
                type="radio"
                role="radio"
                :disabled="isCheckboxDisabled(option)"
              >
                <template #label>
                  <div v-orphans class="mt-1">{{ checkboxLabel(option) }}</div>
                </template>
              </FormCheckbox>
            </div>
          </b-col>
        </b-row>
      </b-collapse>
    </b-row>
  </b-col>
</template>

<script>
import FormCheckbox from '@/components/widgets/forms/FormCheckbox.vue'

export default {
  name: 'FilterInput',
  components: { FormCheckbox },
  props: {
    value: {},
    autoHeight: {
      type: Boolean,
      default: false
    },
    label: {
      required: true,
      type: String
    },
    validationLabel: {
      required: false,
      type: String
    },
    showFilterInput: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      required: true
    },
    limit: {
      type: Number,
      required: false,
      default: 0
    },
    radio: {
      type: Boolean,
      default: false
    },
    clearFilterValue: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    filteredOptions() {
      if (this.showFilterInput && this.filterValue) {
        return this.options.filter((el) =>
          el.toLowerCase().includes(this.filterValue.toLowerCase())
        )
      }
      return this.options
    },
    showValidationWarning() {
      return this.limit > 0 && this.value?.length >= this.limit
    }
  },
  data() {
    return {
      visible: true,
      checkbox: [],
      filterValue: null
    }
  },
  watch: {
    clearFilterValue(clearFilterValue) {
      if (clearFilterValue) {
        this.filterValue = null
      }
    }
  },
  methods: {
    checkboxLabel(value) {
      if (typeof value === 'string') {
        return value
      }
      if (typeof value === 'object') {
        if (value.title) {
          return value.title
        }
        if (value.display_value) {
          return value.display_value
        }
        if (value.name) {
          return value.name
        }
      }
      return value
    },
    checkboxValue(value) {
      if (value.id) {
        return value.id
      }
      return value
    },
    /**
     * This function ensure that after filtering checkboxes
     * FormCheckbox'es components updates correctly. This fix NAP-1564 bug
     * @param option - item from filteredOptions array.
     * @param {number} index - index of item from filteredOptions.
     * @returns unique key for item from filteredOptions.
     */
    indexWithCheckboxValue(option, index) {
      return this.checkboxValue(option) + index
    },
    toggle() {
      this.visible = !this.visible
      this.$store.dispatch('filter/toggleInputVisibility', this.label)
    },
    isCheckboxDisabled(option) {
      return this.limit > 0 && this.value.length >= this.limit && !this.value.includes(option)
    }
  },
  created() {
    const hiddenInputsList = this.$store.getters['filter/getHiddenInputsList']
    this.visible = !!hiddenInputsList.find((key) => key === this.label)
  }
}
</script>
